import {
  IAcquisitionStore,
  TAcquisitionState,
  TBooleanField,
  TInputField,
} from "../../providers/ModernAcquisitionProvider/types";

const modernReadManager = (
  acquisitionStore: IAcquisitionStore,
  modernFields: Array<keyof TAcquisitionState>,
) => {
  const normalize = () => {
    const normalizedState: TAcquisitionState = {};
    const acquisitionState = acquisitionStore.getState();

    modernFields.forEach((fieldKey) => {
      const fieldObj = acquisitionState[fieldKey];
      if(!fieldObj) {
        return;
      }
      if (fieldKey !== 'authorizedUserSpouse') {
        normalizedState[fieldKey] = {
          ...fieldObj,
        } as Partial<TInputField>;
      }
    });

    // ensure a completely new object with no refs to the original
    return JSON.parse(JSON.stringify(normalizedState));
  };

  return {
    normalize,
  };
};

export default modernReadManager;
